import united_state from "../assets/images/flags/us.jpg";
import mexico from "../assets/images/flags/mexico.jpg";
import i18n from "../i18n";

const languages = {
  sp: {
    label: i18n.t("Spanish"),
    flag: mexico,
  },
  en: {
    label: i18n.t("English"),
    flag: united_state,
  },
};

export default languages;
